(function () {
  var input = document.querySelector('[data-search-input]');
  var results = document.querySelector('[data-search-results]');
  if (!input || !results) return;
  var t;
  input.addEventListener('input', function () {
    clearTimeout(t);
    var q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    t = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,vendor,tag')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (products.length === 0) { results.innerHTML = '<p class="muted-sm">No matches for "' + q.replace(/</g, '') + '".</p>'; return; }
          results.innerHTML = products.map(function (p) {
            return '<a class="search-hit" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="" width="48" height="48">' : '') +
              '<span><strong>' + p.title + '</strong><br><small>' + p.price + '</small></span></a>';
          }).join('') + '<a class="search-hit search-hit-all" href="/search?q=' + encodeURIComponent(q) + '">See all results →</a>';
        }).catch(function () { results.innerHTML = ''; });
    }, 220);
  });
})();
